// Reenvía a un mail personal vía Cloudflare Email Routing (no es una casilla
// nueva a revisar aparte).
export const EMAIL_BAJA_DATOS = "privacidad@ingcome.com.ar";

export const FUENTES = [
  {
    nombre: "ARCA — Registro Nacional de Sociedades",
    url: "https://www.argentina.gob.ar/justicia/registro-nacional-sociedades",
  },
  {
    nombre: "Boletín Oficial de Mendoza",
    url: "https://informacionoficial.mendoza.gob.ar/boletinoficial/",
  },
  {
    nombre: "AFIP — Padrón de Contribuyentes (Archivo Completo)",
    url: "https://www.afip.gob.ar/genericos/cInscripcion/archivoCompleto.asp",
  },
];
